import { environment } from '../../../environments/environment';

const UtilsSerice = {
  debugLog: (...messages: any[]) => {
    if (environment.showDebug) {
      messages.forEach((message) => {
        console.log(`[DEBUG]`, message);
      });
    }
  },

  appendUrlArguments: (url: string, argumentsObject: Record<string, string>) => {
    const queryString = Object.keys(argumentsObject)
      .map((key) => `${key}=${argumentsObject[key]}`)
      .join('&');
    return `${url}?${queryString}`;
  },
};

export default UtilsSerice;
